export default __webpack_public_path__ + "static/media/answer_left.320cf60d.png";